module.exports = __webpack_public_path__ + "static/heirloom-293d419e2773a822064968fd791549db.png";